import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import routes from "routes";

const commitHash = import.meta.env.VITE_APP_COMMIT_HASH || "unknown";

const hostname = window.location.hostname;
const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
const sentryEnabled = !isLocalhost;

Sentry.init({
  dsn: "https://5abb83401ba759636d4a52238fd777e2@o4504530781732864.ingest.us.sentry.io/4511257827409920",
  integrations: sentryEnabled
    ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
    : [],
  tracePropagationTargets: [
    /^https:\/\/global[-.].*\.arkion\.co/,
    /^https:\/\/api\.global[-.].*\.arkion\.co/,
  ],
  environment: window.location.host,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: commitHash,
  beforeSend(event, hint) {
    console.error(hint?.originalException);
    if (!sentryEnabled) return null;
    return event;
  },
});

const router = createBrowserRouter(routes);

(async () => {
  const loadApp = async () => {
    const container = document.getElementById("root");
    if (!container) throw new Error("Root container not found");
    createRoot(container).render(
      <>
        <RouterProvider router={router} />
        <ToastContainer position="bottom-right" />
      </>
    );
  };

  if (document.visibilityState === "visible") {
    await loadApp();
  } else {
    document.addEventListener("visibilitychange", async function onVisibilityChange() {
      if (document.visibilityState === "visible") {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        await loadApp();
      }
    });
  }
})();
